<template>
<div id="app">
    <div class="reform">
        <div class="regiWrap">
            <p class="regTit tc">登录喜马拉雅</p>
            <div class="regiBox">
                <a href="" class="change-ways" @click.stop.prevent="toggleLoginWay"></a>
                <div class="regiLogo inl-b">
                    <div class="whiteLogo"></div>
                    <p class="regWayTxt">或者使用第三方登录</p>
                    <div class="regLoginWays">
                        <a href="javascript:;" @click="authLogin('weixin')" class="regLoginWx"><i class="iconfont icon-weixin"></i></a>
                        <a href="javascript:;" @click="authLogin('tQQ')" class="regLoginQq"><i class="iconfont icon-ic_qq"></i></a>
                        <a href="javascript:;" @click="authLogin('tSina')"  class="regLoginWb"><i class="iconfont icon-ic_weibo"></i></a>
                    </div>
                </div>
                <div class="regFormBox inl-b">
                    <component :is="curView"></component>
                </div>
            </div>
        </div>
    </div>
    <transition-group name="pop">
      <pop-bindphone :visible="bindphoneVisible" key="binPhone"></pop-bindphone>
    </transition-group>
    <pop-smsCode key="smsCode"></pop-smsCode>
    <pop-imageCode key="imageCode"></pop-imageCode>
</div>
</template>

<script>
import qrcodeLogin from '@/components/qrcode-login'
import jForm from '@/components/j-form'
import popBindphone from '@/components/pop-bindphone'
import popSmsCode from '@/components/pop-smsCode'
import popImageCode from '@/components/pop-imageCode'
import { addBind } from '@/third-part'
import { queryHref } from '@/common/utils'
// 页面中引入埋点依赖
(function(e, t, n, a, o, i, m) {
  e._xmObjName = o,
    e[o] = e[o] || function() {
      (e[o].q = e[o].q || []).push(arguments)
    },
    e[o].l = e[o].l || +new Date,
    i = t.createElement(n),
    i.async = true,
    i.src = a,
    m = t.getElementsByTagName(n)[0],
    m.parentNode.insertBefore(i, m)
})(window, document, "script", "//s1.xmcdn.com/lib/xmlog/last/xmlog.js", "xmLog");

export default {
  name: 'app',
  components: {
    qrcodeLogin,
    jForm,
    popBindphone,
    popSmsCode,
    popImageCode
  },
  data () {
    return {
      curView: 'jForm',
      bindphoneVisible: true,
      codeVisible: false
    }
  },
  computed: {
    toUrl () {
      return this.$store.state.toUrl
    }
  },
  methods: {
    toggleLoginWay () {
      if (this.curView == 'jForm') {
        this.curView = 'qrcodeLogin'
      } else {
        this.curView = 'jForm'
      }
      //切换登录方式的点击埋点
      xmLog && xmLog('pv.send', 'event', {
        currPage: "login",
        currPageId: null,
        currPageUrl: "/passport/login",
        item: `${this.curView == 'jForm' ? "password" : "2dCode"}`,
        itemId:null,
        module: null,
        serviceId: "click",
      })
    },
    authLogin(name) {
      /* 点击第三方登录埋点 */
      const _item = name === 'weixin' ? name : (name === 'tQQ' ? "qq" : "weibo")
      xmLog && xmLog('pv.send', 'event', {
        currPage: "login",
        currPageId: null,
        currPageUrl: "/passport/login",
        item: _item,
        itemId:null,
        module: null,
        serviceId: "click",
      })
      addBind(name, ({toUrl, uid, gotoBindMPhone, checkKey}) => {
        if (gotoBindMPhone) {
          this.$store.commit('changeBindStatus', 'TO_BIND')
          this.$store.commit('setCheckKey', checkKey)
          toUrl && this.$store.commit('setToUrl', toUrl)
        } else {
          window.location.href = this.toUrl
        }
      })
    },
    authRegister(){
      //点击注册时埋点
      xmLog && xmLog('pv.send', 'event', {
        currPage: "login",
        currPageId: null,
        currPageUrl: "/passport/login",
        item: "register",
        itemId:null,
        module: "bottomTool",
        serviceId: "click",
      })
    },
    pageViewLog(){
      /* 页面进入时的埋点 */
      xmLog && xmLog('pv.create', {
        currPage: 'login',
      })
      xmLog && xmLog('pv.send', 'event', {
        currPage: "login",
        currPageId: null,
        currPageUrl: "/passport/login",
        durationTime: "0s",
        prevItem: null,
        prevItemId: null,
        prevModule: null,
        prevPage: null,
        prevPageId: null,
        prevPageUrl: null,
        serviceId: "pageView",
      })
    }
  },
  created () {
    let toUrl = queryHref('fromUri')

    if (!!toUrl) {
      this.$store.commit('setToUrl', decodeURIComponent(toUrl))
    }
  },
  mounted() {
    this.codeVisible = true
    this.pageViewLog()
  },
}
</script>
<style>
.pop-enter-active,
.pop-leave-active {
  transition: all .7s ease;
}
.pop-enter {
  transform: translate3d(0, -100%, 0);
}

</style>



// WEBPACK FOOTER //
// src/App.vue